import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';

registerBlockType('puroclean/faq-section', {
    edit: Edit,
}); 